exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".chat{position:absolute;bottom:0;padding:0;margin:0!important;left:0;right:0;z-index:3;background-color:hsla(0,0%,40%,.7)!important}.chat.minimized .panel-body,.chat.minimized .panel-footer{display:none}.chat .panel-heading{padding:0}.chat .btn,.chat .panel-heading{background-color:transparent!important}.chat .btn{margin:0;color:#000!important}.chat .panel-body{padding:0;height:200px;overflow:auto}.chat .panel-footer{border-color:#666;background-color:transparent!important}.chat .list-group-item-heading{font-weight:500;font-size:1em!important;overflow:hidden;text-overflow:ellipsis}.chat .list-group-item-text{color:#eee;font-size:1.2em!important}.chat .list-group-item{margin-bottom:5px}.chat .form-control{color:#eee}@media (min-width:768px){.chat{left:15%;right:15%}.chat .panel-body{height:250px}}@media (min-width:992px){.chat{left:20%;right:20%}.chat .panel-body{height:300px}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/js/components/styles/chat.less
 ** module id = 453
 ** module chunks = 1
 **/